import React, { useEffect, useRef } from 'react'
import katex from 'katex'

import { quillService } from '../services/quill.service'

export const RichText = function ({ value, className = '', style = {} }) {
  const contentRef = useRef()

  const html = value ? quillService.convertDeltaToHtml(value) : ''

  useEffect(() => {
    const formulaElements = contentRef.current.querySelectorAll('.ql-formula')
    formulaElements.forEach((formulaElement) => {
      katex.render(formulaElement.innerText, formulaElement, { throwOnError: false })
    })
  }, [])

  return (
    <div className={className} ref={contentRef} style={style} dangerouslySetInnerHTML={{ __html: html }} />
  )
}
